import { render, staticRenderFns } from "./courseBookList.vue?vue&type=template&id=b189cdbc&scoped=true&"
import script from "./courseBookList.vue?vue&type=script&lang=js&"
export * from "./courseBookList.vue?vue&type=script&lang=js&"
import style0 from "./courseBookList.vue?vue&type=style&index=0&id=b189cdbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b189cdbc",
  null
  
)

export default component.exports